<template>
  <div class="ts-app-shell_fh">
  <RegistrationQuestionnaire :currentPage="currentPageStep">
    <div class="check-list-form">
      <div class="content-type">
        <span>Registration Information</span>
      </div>
      <el-form
        :model="registrationAnswer"
        @submit.native.prevent="updateRegistrationAnswers"
      >
        <p>Please provide registration information in order for us to best serve you</p>
        <p class="heavy-text">Additional Information</p>
        <div class="content-item">
          <el-row>
            <div class="mb-2 flex items-center text-sm">
              <label role="text">
                Have you been affected by the COVID-19 Pandemic?
              </label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'AdditionalInfo.AffectedByCOVIDPandemic'
                  )
                "
              >
                <el-radio-group
                  v-model="registrationAnswer.additionalInfo.affectedByCOVIDPandemic"
                  class="ml-4"
                >
                  <el-radio :label="0" size="large">Yes</el-radio>
                  <el-radio :label="1" size="large">No</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-row>
        </div>
        <div class="content-item">
          <el-row>
            <el-col :xl="24" :lg="24" :md="24" :sm="24">
              <label role="text">Please select a method in which you prefer to receive your notifications:</label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'AdditionalInfo.NotificationMethod'
                  )
                "
              >
                <el-select v-model="registrationAnswer.additionalInfo.notificationMethod" placeholder="Select">
                  <el-option
                    v-for="item in notificationOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="content-item">
          <el-row>
            <el-col :xl="24" :lg="24" :md="24" :sm="24">
              <label role="text">From where are you accessing the website:</label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'AdditionalInfo.WebsiteAccess'
                  )
                "
              >
                <el-select v-model="registrationAnswer.additionalInfo.websiteAccess" placeholder="Select">
                  <el-option
                    v-for="item in accessOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="content-item">
          <el-row>
            <el-col :xl="24" :lg="24" :md="24" :sm="24">
              <label role="text">How did you hear about us:</label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'AdditionalInfo.HowDidYouHearAboutUs'
                  )
                "
              >
                <el-select v-model="registrationAnswer.additionalInfo.howDidYouHearAboutUs" placeholder="Select">
                  <el-option
                    v-for="item in aboutUsOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="content-item action-section">
          <el-row>
            <el-col span="8">
              <el-button
                class="ts-btn ts-btn-outline wioa-btn-outline"
                @click="backToDashboard"
              >
                Previous
              </el-button>
            </el-col>
            <el-col span="8">
              <el-button
                class="ts-btn ts-btn-secondary"
                @click="updateRegistrationAnswers"
              >
                Complete
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
  </RegistrationQuestionnaire>
  <TSLoading
      :active="isLoading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process your data...'"
    />
  </div>
</template>

<script>
import RegistrationQuestionnaire from "../../component/RegistrationQuestionnaire.vue";
import TSLoading from "../../../../components/TSLoading.vue";

export default {
  components: { RegistrationQuestionnaire, TSLoading },
  data(){
    return{
      checklist: ['Asian', 'White'],
      modelState: {},
      isLoading: false,
      registrationAnswer: {
        priorityOfService: {},
        militaryService: {},
        veteranInfo: {},
        transitioningServiceMembers: {},
        militaryMemberSpouse: {},
        disability: {},
        householdInfo: {},
        publicAssistance: {},
        demographicInfo: {},
        ethnicOrigin: {},
        race: {
          raceSelection: []
        },
        language: {},
        educationInfo: {},
        employmentInfo: {},
        farmworkerInfo: {},
        additionalInfo: {},
      },
      additionalInfoEmpty: {
        affectedByCOVIDPandemic: null,
        notificationMethod: null,
        websiteAccess: null,
        howDidYouHearAboutUs: null,
      },
      jobSeekerId: null,
      notificationOptions: [{
          value: 'Internal Message',
          label: 'Internal Message'
        }, {
          value: 'Email',
          label: 'Email'
        }, {
          value: 'Text Message (if available)',
          label: 'Text Message (if available)'
        }, {
          value: 'Internal Message with Email',
          label: 'Internal Message with Email'
        }, {
          value: 'Phone',
          label: 'Phone'
        }],
      accessOptions: [{
          value: 'Home',
          label: 'Home'
        }, {
          value: 'Work',
          label: 'Work'
        }, {
          value: 'Job Center',
          label: 'Job Center'
        }, {
          value: 'Job Fair',
          label: 'Job Fair'
        }, {
          value: 'Library',
          label: 'Library'
        }, {
          value: 'Community Center',
          label: 'Community Center'
        }, {
          value: 'Place of Worship',
          label: 'Place of Worship'
        }, {
          value: 'Military Location',
          label: 'Military Location'
        }, {
          value: 'Youth Center',
          label: 'Youth Center'
        }, {
          value: 'Correctional Facility',
          label: 'Correctional Facility'
        }, {
          value: 'Elementary School',
          label: 'Elementary School'
        }, {
          value: 'Middle School',
          label: 'Middle School'
        }, {
          value: 'High School',
          label: 'High School'
        }, {
          value: 'College',
          label: 'College'
        }, {
          value: 'Other',
          label: 'Other'
        }],
      aboutUsOptions: [{
          value: 'Another Website',
          label: 'Another Website'
        }, {
          value: 'Business Colleague',
          label: 'Business Colleague'
        }, {
          value: 'Friend',
          label: 'Friend'
        }, {
          value: 'Job Fair',
          label: 'Job Fair'
        }, {
          value: 'Job Center/One Stop',
          label: 'Job Center/One Stop'
        }, {
          value: 'Magazine Ad',
          label: 'Magazine Ad'
        }, {
          value: 'Radio Ad',
          label: 'Radio Ad'
        }, {
          value: 'Television Ad',
          label: 'Television Ad'
        }, {
          value: 'Trade Show / Conference',
          label: 'Trade Show / Conference'
        }, {
          value: 'Attended Rapid Response',
          label: 'Attended Rapid Response'
        }, {
          value: 'Career Coach Mobile Facility',
          label: 'Career Coach Mobile Facility'
        }, {
          value: 'Other',
          label: 'Other'
        }],
    }
  },
  computed: {
    currentPageStep() {
      return this.$route.meta.currentPage;
    },
  },
  created() {
    window.scrollTo(0,0);
    this.isLoading = true;
    this.jobSeekerId = this.$store.state.account.applicant_user_info.jobSeekerId;
    this.$store
      .dispatch("jobseeker/getRegistrationAnswerByJobSeekerId", this.jobSeekerId)
      .then((res) => {
        if (res === null || res === undefined || res.priorityOfService === null) {
          this.$router.push({ name: "RegistrationQuestionnaireOne" });
        } else {
          this.registrationAnswer = res;

          this.registrationAnswer.additionalInfo = this.registrationAnswer.additionalInfo === null 
            ? this.additionalInfoEmpty 
            : this.registrationAnswer.additionalInfo;
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  methods: {
    backToDashboard() {
      this.$router.push({ name: "RegistrationQuestionnaireSix" });
    },
    updateRegistrationAnswers() {
      this.isLoading = true;
      this.registrationAnswer.validatePageType = 7;
      this.registrationAnswer.isCompleted = true;
      
      this.$store
        .dispatch("jobseeker/updateRegistrationAnswer", this.registrationAnswer)
        .then(res => {
          if (res) {
            this.$router.push({ name: "jobseeker-dashboard" });
          }
        })
        .catch(res => {
          this.modelState = res;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
